import { ApplicationState } from '@app/store'
import {
  actionCreators,
  IGlobalCompanyContactsState,
  selectCompanyContacts,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { AssociatedContactSelector } from '../components/AssociatedContactSelector'

export default connect(
  createStructuredSelector<ApplicationState, IGlobalCompanyContactsState>({
    companyContacts: selectCompanyContacts(),
  }),
  actionCreators,
)(AssociatedContactSelector)
